<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="记事内容" left-text="返回" left-arrow @click-left="goBack">
				
			</van-nav-bar>
		</div>
		<div class="projectItem isNotesDetail">
			<van-row gutter="20" class="notesTop">
				<van-col span="8">{{record.recTime}}</van-col>
				<van-col span="8" align="center">{{record.recMan}}</van-col>
				<van-col span="8" align="right">
					<div class="weather">{{record.weather}}&nbsp;{{record.temperature}}</div>
				</van-col>
			</van-row>
			<p class="notesDetailText" style="white-space: pre-wrap;">{{record.recContent}}</p>
		</div>
	</div>
</template>
<script>
	import { noteInfo } from '@/api/notes';
	export default {
		name: 'notesDetail',
		data() {
			return {
				id: '',
				record: '',
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			if (this.id != '' && this.id != null && this.id != 'undefined'){
				this.getDetail(this.id);
			}
		},
		methods: {
			getDetail(id){
				noteInfo(id).then(response => {
					if(response.data.messageCode != "SUCCESS") {
						Notify({ type: 'danger', message: response.data.resultMessage });
						return
					}
					this.record = response.data.body
					console.log('record', this.record)
				})
			},
			goBack() {
				this.$router.push({
					name: 'notesList'
				});
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>